import { t } from "../../../global/Localization/translation";
import { getBrowserLocale } from "../../../utils/browser";
import "./PlaylistListMeta.scss";

interface Props {
  length: number;
  total: number;
}

const PlaylistListMeta = (props: Props) => {
  return (
    <div className="playlists-list-meta">
      {t("playlists.list.length", {
        length: new Intl.NumberFormat(getBrowserLocale()).format(props.length),
        total: new Intl.NumberFormat(getBrowserLocale()).format(props.total),
      })}
    </div>
  );
};

export default PlaylistListMeta;
